export const baseTheme = {
  typography: {
    fontWeightLight: 400,
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: '2.875rem',
      letterSpacing: '-1.5px',
    },
    h2: {
      fontWeight: 700,
      fontSize: '1.875rem',
      lineHeight: '2.3125rem',
      letterSpacing: '-0.5px',
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: '2rem',
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: '2rem',
      letterSpacing: '0.25px',
    },
    h5: {
      fontWeight: 700,
      fontSize: '0.875rem',
      lineHeight: '1.3125rem',
    },
    h6: {
      fontWeight: 700,
      fontSize: '0.7rem',
      lineHeight: '1rem',
      letterSpacing: '0.15px',
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: '1.5rem',
      letterSpacing: '0.15px',
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      letterSpacing: '0.15px',
    },
    body1: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: '1.5rem',
      letterSpacing: '0.5px',
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      letterSpacing: '0.25px',
    },
    caption: {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: '1rem',
      letterSpacing: '0.4px',
    },
    overline: {
      fontWeight: 400,
      fontSize: '10px',
      lineHeight: '1rem',
      letterSpacing: '1.5px',
    },
  },
};
